import React, { useEffect, useState } from 'react';
import api from '../utils/api';

// Аналитика привычек «Мой день»
const fmt = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const dayList = n => [...Array(n)].map((_, i) => { const d = new Date(); d.setDate(d.getDate() - (n - 1 - i)); return fmt(d); });
const PERIODS = [[7, 'Неделя'], [30, 'Месяц'], [90, '3 месяца'], [365, 'Год']];

export default function HabitsPage() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/habits/stats', { params: { day: fmt(new Date()), days } }).then(r => setData(r.data)).catch(() => {});
  }, [days]);

  if (!data) return <div>Загрузка…</div>;

  const list = dayList(days);
  const today = list[list.length - 1];
  const marked = new Set(data.marks.map(m => m.day + '|' + m.habit));
  const has = (d, k) => marked.has(d + '|' + k);
  const total = data.habits.length;
  // считаем только дни с начала учёта, чтобы до старта не было «провалов»
  const counted = list.filter(d => data.since && d >= data.since);
  const pct = (n, of) => of ? Math.round(n / of * 100) : 0;

  // серия: подряд до сегодня (сегодня, если ещё не отмечено, серию не рвёт)
  const streak = k => {
    let n = 0;
    for (let i = list.length - 1; i >= 0; i--) {
      if (has(list[i], k)) n++;
      else if (list[i] === today) continue;
      else break;
    }
    return n;
  };
  const dayScore = d => data.habits.filter(h => has(d, h.key)).length;
  const fullDays = counted.filter(d => dayScore(d) === total).length;
  const avg = counted.length ? pct(counted.reduce((a, d) => a + dayScore(d), 0), counted.length * total) : 0;

  const cell = on => ({ width: days > 90 ? 4 : days > 30 ? 8 : 16, height: 16, borderRadius: 3, background: on ? '#16a34a' : '#eef2f6', flexShrink: 0 });
  const scoreColor = r => r >= 1 ? '#16a34a' : r >= 0.7 ? '#86efac' : r > 0 ? '#fde68a' : '#eef2f6';

  return (
    <div style={{ maxWidth: 1100 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
        <h1 className="page-title" style={{ margin: 0 }}>Мой день — аналитика</h1>
        <div style={{ display: 'flex', gap: 4, marginLeft: 'auto' }}>
          {PERIODS.map(([n, l]) => (
            <button key={n} className={'btn ' + (days === n ? 'btn-primary' : 'btn-secondary')} onClick={() => setDays(n)}>{l}</button>
          ))}
        </div>
      </div>

      {!data.since ? (
        <div className="card" style={{ padding: 20 }}>Отметок пока нет. Отмечайте пункты в блоке «Мой день» в меню слева — здесь появится статистика.</div>
      ) : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 16 }}>
            <Stat label="Выполнение за период" value={avg + '%'} />
            <Stat label="Идеальных дней (все пункты)" value={`${fullDays} из ${counted.length}`} />
            <Stat label="Сегодня" value={`${dayScore(today)}/${total}`} />
            <Stat label="Учёт ведётся с" value={data.since.split('-').reverse().join('.')} />
          </div>

          <div className="card" style={{ padding: 16, overflowX: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
              <div style={{ width: 230, flexShrink: 0, fontSize: 12, color: '#8fa0b4' }}>ДЕНЬ ЦЕЛИКОМ</div>
              <div style={{ display: 'flex', gap: 2 }}>
                {list.map(d => <span key={d} title={d.split('-').reverse().join('.') + ': ' + dayScore(d) + '/' + total}
                  style={{ ...cell(false), background: scoreColor(dayScore(d) / total) }} />)}
              </div>
            </div>
            {data.habits.map(h => {
              const n = counted.filter(d => has(d, h.key)).length;
              return (
                <div key={h.key} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6 }}>
                  <div style={{ width: 230, flexShrink: 0, fontSize: 13 }}>
                    <div>{h.label}</div>
                    <div style={{ fontSize: 11, color: '#8fa0b4' }}>{pct(n, counted.length)}% · серия {streak(h.key)} дн.</div>
                  </div>
                  <div style={{ display: 'flex', gap: 2 }}>
                    {list.map(d => <span key={d} title={d.split('-').reverse().join('.')} style={cell(has(d, h.key))} />)}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

const Stat = ({ label, value }) => (
  <div className="card" style={{ padding: 14 }}>
    <div style={{ fontSize: 11, color: '#8fa0b4', marginBottom: 4 }}>{label}</div>
    <div style={{ fontSize: 22, fontWeight: 700 }}>{value}</div>
  </div>
);
